import { AUTH_ACTIONS } from "../constants/constants";
import {
  AuthTokenState,
  AuthTokenStateDefault,
} from "../states/authTokenState";

export const AuthReducer = (
  state: AuthTokenState = AuthTokenStateDefault,
  { type, payload }: any
) => {
  switch (type) {
    case AUTH_ACTIONS.LOG_IN:
      return {
        ...state,
        ...payload,
      };
    case AUTH_ACTIONS.LOG_OUT:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
